import React, { Component } from 'react';
import { Dropdown, Icon, Menu, Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import { Link, withRouter } from 'react-router-dom';

// authMenu component create dropdown menu if user has not logged in;
class authMenu extends Component {
  render() {
    const menu = (
      <Menu className="landing__header--dropdown">
        <Menu.Item key="0">
          <Link to={{ pathname: '/login', state: { prevPath: this.props.location.pathname } }}>
            <FormattedMessage id="landing.login" defaultMessage="Login" description="login" />
          </Link>
        </Menu.Item>
        <Menu.Item key="1">
          <Link to="/signup">
            <FormattedMessage id="landing.signup" defaultMessage="Signup" description="signup" />
          </Link>
        </Menu.Item>
      </Menu>
    );
    return (
      <Dropdown overlay={menu} trigger={['click']}>
        <a className="ant-dropdown-link" href="#">
          <FormattedMessage id="login.title" defaultMessage="Login" description="login" />
          <Icon type="caret-down" />
        </a>
      </Dropdown>
    );
  }
}

export default withRouter(authMenu);



// WEBPACK FOOTER //
// ./src/components/landing/auth-menu.js